
import React from 'react';
import { Progress } from "@/components/ui/progress";

export const LoadingState: React.FC = () => {
  return (
    <div className="p-8 flex justify-center">
      <Progress value={30} className="w-1/2" />
    </div>
  );
};
